import { render, staticRenderFns } from "./bx.new.vue?vue&type=template&id=bf0b65ba&"
import script from "./bx.new.vue?vue&type=script&lang=js&"
export * from "./bx.new.vue?vue&type=script&lang=js&"
import style0 from "./bx.new.vue?vue&type=style&index=0&id=bf0b65ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports